import React from "react";
import { computeCardHeight, makeCard } from "./utils"
import { Button } from '@kdcloudjs/kdesign'
import "./showCard.less"
import "./cardStyle.less"

function ShowCard(props) {
  console.log("===app===", props);

  const { currCardModel, editCardModel, lock, cardStyle, I18N } = props

  const editHandle = () => {
    editCardModel()
  }

  return (
    <div className="show-card-wrappper">
      <div className="info">
        <div className="cardmodel-box">
          <div className={`model`} style={{
            height: computeCardHeight(currCardModel),
            background: cardStyle.backgroundcolor,
            border: "1px solid " + cardStyle.bordercolor,
          }}>
            {
              cardStyle.topbordercolor && (
                <div className="topBar" style={{ background: cardStyle.topbordercolor }}></div>
              )
            }
            {currCardModel.map(fields => makeCard(fields))}
          </div>
        </div>
      </div>
      {
        !lock && (
          <div className="btn">
            <Button onClick={editHandle} type="ghost" >{I18N("op.edit")}</Button>
          </div>
        )
      }
    </div>
  )
}

export default ShowCard